const Header = ({title, icon: Icon, onBack}) => {
  
  return (
    <div style={styles.header}>
      <div style={styles.headerContent}>
        {/* Botão Voltar no canto superior esquerdo */}
        {onBack && (
          <button 
            onClick={onBack}
            style={styles.backButton}
            aria-label="Voltar"
          >
            Voltar
          </button>
        )}
        
        <div style={styles.titleContainer}>
          <h1 style={styles.titulo}>
            {Icon && <Icon style={styles.icon} />}
            {title}
          </h1>
        </div>
      </div>
    </div>
  );
};

const styles = {
  header: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    padding: '16px 20px',
    background: 'rgb(220, 225, 247)',
    color: '#fff',
    fontFamily: 'Montserrat, sans-serif',
    justifyContent: 'center',
    width: '100%',
    marginBottom: '40px',
    position: 'relative', // Adicionado para posicionamento absoluto do botão
  },
  headerContent: {
    display: 'flex',
    alignItems: 'center',
    width: '100%',
    maxWidth: '1200px',
    position: 'relative',
    justifyContent: 'center', // Centraliza o título
  },
  backButton: {
    position: 'absolute',
    left: '2px', // Distância da borda esquerda
    top: '50px', // Distância do topo
    fontFamily: 'Montserrat, sans-serif',
    background: 'none',
    border: 'none',
    cursor: 'pointer',
    fontSize: '18px',
    fontWeight: '400',
    color: '#09448C',
    padding: '8px 12px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: '32px',
    height: '32px',
    borderRadius: '4px',
    transition: 'background-color 0.2s ease',
    zIndex: 10,
  },
  titleContainer: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    width: '100%',
  },
  titulo: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    gap: '15px',
    fontSize: '1.3em',
    margin: 0,
    color: '#09448C',
    fontWeight: '600',
  },
  icon: {
    color: '#09448C',
    fontSize: '24px',
  },
}

// Adicionando efeito hover para melhor UX
styles.backButton[':hover'] = {
  backgroundColor: 'rgba(9, 68, 140, 0.1)',
};

export default Header;